/**
 * A/B Test — Travelpack BOGO social proof + gallery badges
 * Page: /pages/travelpack-bogo (incl. /de/pages/travelpack-bogo)
 * Toggle: body[data-bogo-social-proof-ab="true|false"]
 *   - false (Control): "Recommended by…" + existing Excellent rating row
 *   - true  (Variant): Kim social proof replaces Recommended-by row (above H2);
 *                      Excellent rating row hidden; page review count used;
 *                      gallery badges + Red Dot / iF awards shown;
 *                      click scrolls to [data-section-id="s_reviews"]
 *
 * For Intelligems, set data-bogo-social-proof-ab on <body>.
 * Dev preview: ?bogo_social_proof_test=b
 */
(function () {
  'use strict';

  if (window.__bogoSocialProofAbInit) return;
  window.__bogoSocialProofAbInit = true;

  var ATTR = 'data-bogo-social-proof-ab';
  var VARIANT_ATTR = 'data-bogo-sp-variant';
  var BADGES_ATTR = 'data-bogo-sp-badges';
  var ACTIVE_CLASS = 'bogo-social-proof-ab--active';
  var RATING_HIDDEN_ATTR = 'data-bogo-sp-rating-hidden';
  var RECOMMEND_HIDDEN_ATTR = 'data-bogo-sp-recommend-hidden';
  var GALLERY_MARK = 'data-bogo-social-proof-ab-root';

  var AWARD_REDDOT =
    'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Logo_of_Red_Dot_Award.svg?v=1770759651';
  var AWARD_IF =
    'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/IF.png?v=1770759648';
  var AVATAR_1 =
    'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Ellipse_9.png?v=1782742719';
  var AVATAR_2 =
    'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Ellipse_8.png?v=1782742731';
  var AVATAR_3 =
    'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Ellipse_7.png?v=1782742743';

  var applying = false;
  var rafScheduled = false;
  var lastEnabled = null;
  var lastAttrValue = null;

  function isDevVariantB() {
    try {
      var v = new URLSearchParams(window.location.search).get('bogo_social_proof_test');
      return v === 'b' || v === 'true' || v === '1';
    } catch (e) {
      return false;
    }
  }

  function isTruthy(value) {
    var normalized = String(value || '')
      .trim()
      .toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'on' || normalized === 'yes';
  }

  function isAbEnabled() {
    if (isDevVariantB()) return true;
    if (!document.body) return false;
    return (
      isTruthy(document.body.getAttribute(ATTR)) ||
      isTruthy(document.documentElement.getAttribute(ATTR))
    );
  }

  function isTargetPage() {
    var path = String(location.pathname || '').toLowerCase();
    return path.indexOf('/pages/travelpack-bogo') > -1 || path.indexOf('travelpack-bogo') > -1;
  }

  function isGerman() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    return lang.indexOf('de') === 0;
  }

  function getGalleryFrame() {
    var track = document.getElementById('aer-gal-track');
    if (track) {
      return track.closest('.relative') || track.parentElement;
    }
    return document.querySelector('[data-section-id="s_hero"] .relative.bg-gray-50');
  }

  function getRatingRow() {
    var hero = document.querySelector('[data-section-id="s_hero"]');
    if (!hero) return null;
    var buttons = hero.querySelectorAll('button[aria-expanded]');
    for (var i = 0; i < buttons.length; i++) {
      var text = (buttons[i].textContent || '').toLowerCase();
      if (
        text.indexOf('review') > -1 ||
        text.indexOf('bewertung') > -1 ||
        text.indexOf('excellent') > -1 ||
        text.indexOf('4.8') > -1 ||
        text.indexOf('4,8') > -1
      ) {
        return buttons[i].closest('.relative.inline-block') || buttons[i].parentElement || buttons[i];
      }
    }
    return null;
  }

  /** "Recommended by Sophie Carter | Travel blogger" row above the H2 */
  function getRecommendRow() {
    var hero = document.querySelector('[data-section-id="s_hero"]');
    if (!hero) return null;
    var col = hero.querySelector('.space-y-4');
    if (!col) return null;

    var nodes = col.children;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute && el.getAttribute(VARIANT_ATTR)) continue;
      var text = (el.textContent || '').toLowerCase();
      if (
        text.indexOf('recommended by') > -1 ||
        text.indexOf('empfohlen') > -1 ||
        (el.querySelector && el.querySelector('img.rounded-full, img.w-10'))
      ) {
        if (text.indexOf('recommended') > -1 || text.indexOf('empfohlen') > -1 || text.indexOf('blogger') > -1) {
          return el;
        }
      }
    }

    // Fallback: first flex row with avatar before h2
    var h2 = col.querySelector('h2');
    if (h2) {
      var prev = h2.previousElementSibling;
      while (prev) {
        if (prev.getAttribute && prev.getAttribute(VARIANT_ATTR)) {
          prev = prev.previousElementSibling;
          continue;
        }
        if (prev.querySelector && prev.querySelector('img')) return prev;
        prev = prev.previousElementSibling;
      }
    }
    return null;
  }

  function setHidden(el, attr, hidden) {
    if (!el) return;
    if (hidden) {
      el.setAttribute(attr, 'true');
      el.style.display = 'none';
    } else {
      el.removeAttribute(attr);
      el.style.display = '';
    }
  }

  /** Read score + review count already shown on this BOGO page (not hardcoded 51k). */
  function getPageReviewStats(ratingAnchor) {
    var score = '4.8';
    var count = '12,400+';
    var de = isGerman();

    var source = ratingAnchor || getRatingRow();
    if (source) {
      var raw = (source.textContent || '').replace(/\s+/g, ' ').trim();
      var scoreMatch = raw.match(/(\d+[.,]\d+)/);
      if (scoreMatch) score = scoreMatch[1];

      var countMatch = raw.match(/([\d.,]+(?:\+)?)[\s]*reviews?/i);
      if (!countMatch) countMatch = raw.match(/([\d.,]+(?:\+)?)[\s]*bewertungen?/i);
      if (countMatch) count = countMatch[1];
    }

    if (de) {
      score = String(score).replace('.', ',');
      return {
        badgePump: 'Incl. Air Pump',
        badgeSale: 'Early Holiday Sale',
        purchase: 'and 1M happy customers',
        rating: score + ' / 5 (' + count + ' reviews)'
      };
    }

    return {
      badgePump: 'Incl. Air Pump',
      badgeSale: 'Early Holiday Sale',
      purchase: 'and 1M happy customers',
      rating: score + ' / 5 (' + count + ' reviews)'
    };
  }

  function scrollToReviews(e) {
    if (e) e.preventDefault();
    var sec = document.querySelector('[data-section-id="s_reviews"]');
    if (!sec) return;
    var startY = window.scrollY || document.documentElement.scrollTop;
    var endY = sec.getBoundingClientRect().top + startY - 60;
    var dur = 650;
    var t0 = null;
    function ease(p) {
      return p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
    }
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      window.scrollTo(0, startY + (endY - startY) * ease(p));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function wireVariantClick(root) {
    if (!root || root.getAttribute('data-bogo-sp-click') === '1') return;
    root.setAttribute('data-bogo-sp-click', '1');
    root.setAttribute('role', 'link');
    root.setAttribute('tabindex', '0');
    root.setAttribute('title', 'See reviews');
    root.style.cursor = 'pointer';
    root.addEventListener('click', scrollToReviews);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        scrollToReviews(e);
      }
    });
  }

  function starSvg() {
    return (
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="#ff5801" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<path d="M12 2l2.9 6.26L22 9.27l-5 4.87L18.18 21 12 17.77 5.82 21 7 14.14 2 9.27l7.1-1.01L12 2z"/>' +
      '</svg>'
    );
  }

  function ensureBadges(gallery, labels) {
    if (!gallery) return null;
    var existing = gallery.querySelector('[' + BADGES_ATTR + ']');
    if (existing) return existing;

    labels = labels || getPageReviewStats();
    var root = document.createElement('div');
    root.setAttribute(BADGES_ATTR, 'true');
    root.className = 'bogo-sp-ab__badges-wrap';
    root.hidden = true;
    root.innerHTML =
      '<div class="bogo-sp-ab__badges" aria-hidden="true">' +
      '<span class="bogo-sp-ab__badge bogo-sp-ab__badge--pump">' +
      labels.badgePump +
      '</span>' +
      '<span class="bogo-sp-ab__badge bogo-sp-ab__badge--sale">' +
      labels.badgeSale +
      '</span>' +
      '</div>' +
      '<div class="bogo-sp-ab__awards" aria-hidden="true">' +
      '<div class="bogo-sp-ab__awards-inner">' +
      '<img src="' +
      AWARD_REDDOT +
      '" alt="" width="70" height="40" loading="lazy" class="bogo-sp-ab__award-img">' +
      '<img src="' +
      AWARD_IF +
      '" alt="" width="70" height="40" loading="lazy" class="bogo-sp-ab__award-img">' +
      '</div>' +
      '</div>';

    gallery.setAttribute(GALLERY_MARK, 'true');
    gallery.appendChild(root);
    return root;
  }

  function ensureVariant(recommendRow, ratingAnchor, labels) {
    var existing = document.querySelector('[' + VARIANT_ATTR + ']');
    if (existing) {
      placeVariant(existing, recommendRow);
      wireVariantClick(existing);
      return existing;
    }

    labels = labels || getPageReviewStats(ratingAnchor);
    var root = document.createElement('div');
    root.setAttribute(VARIANT_ATTR, 'true');
    root.className = 'bogo-sp-ab__variant';
    root.hidden = true;
    root.innerHTML =
      '<div class="bogo-sp-ab__social-row">' +
      '<div class="bogo-sp-ab__avatars" aria-hidden="true">' +
      '<img src="' +
      AVATAR_1 +
      '" alt="" width="30" height="30" loading="lazy">' +
      '<img src="' +
      AVATAR_2 +
      '" alt="" width="30" height="30" loading="lazy">' +
      '<img src="' +
      AVATAR_3 +
      '" alt="" width="30" height="30" loading="lazy">' +
      '</div>' +
      '<p class="bogo-sp-ab__purchase-text">' +
      '<strong>Kim</strong>' +
      '<span class="bogo-sp-ab__verified" aria-label="Verified">' +
      '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<circle cx="7" cy="7" r="7" fill="#1877F2"/>' +
      '<path d="M4 7.2L6.1 9.3L10 5.3" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '</span> ' +
      labels.purchase +
      '</p>' +
      '</div>' +
      '<div class="bogo-sp-ab__rating-row">' +
      '<div class="bogo-sp-ab__stars" aria-hidden="true">' +
      starSvg() +
      starSvg() +
      starSvg() +
      starSvg() +
      starSvg() +
      '</div>' +
      '<span class="bogo-sp-ab__rating-text">' +
      labels.rating +
      '</span>' +
      '</div>';

    placeVariant(root, recommendRow);
    wireVariantClick(root);
    return root;
  }

  function placeVariant(root, recommendRow) {
    if (!root) return;
    if (recommendRow && recommendRow.parentNode) {
      if (root.nextSibling !== recommendRow) {
        recommendRow.parentNode.insertBefore(root, recommendRow);
      }
      return;
    }
    var col = document.querySelector('[data-section-id="s_hero"] .space-y-4');
    if (!col) return;
    var h2 = col.querySelector('h2');
    if (h2) col.insertBefore(root, h2);
    else col.insertBefore(root, col.firstChild);
  }

  function apply() {
    if (applying) return;
    applying = true;

    try {
      if (!isTargetPage()) {
        document.documentElement.classList.remove(ACTIVE_CLASS);
        return;
      }

      var enabled = isAbEnabled();
      var ratingAnchor = getRatingRow();
      var recommendRow = getRecommendRow();
      var gallery = getGalleryFrame();
      var labels = getPageReviewStats(ratingAnchor);
      var variant = ensureVariant(recommendRow, ratingAnchor, labels);
      var badges = ensureBadges(gallery, labels);

      if (variant) {
        var ratingText = variant.querySelector('.bogo-sp-ab__rating-text');
        if (ratingText && ratingText.textContent !== labels.rating) {
          ratingText.textContent = labels.rating;
        }
        wireVariantClick(variant);
      }

      if (enabled) {
        document.documentElement.classList.add(ACTIVE_CLASS);
        if (variant) {
          variant.hidden = false;
          variant.style.display = '';
        }
        if (badges) {
          badges.hidden = false;
          badges.style.display = '';
        }
        setHidden(recommendRow, RECOMMEND_HIDDEN_ATTR, true);
        setHidden(ratingAnchor, RATING_HIDDEN_ATTR, true);
      } else {
        document.documentElement.classList.remove(ACTIVE_CLASS);
        if (variant) variant.hidden = true;
        if (badges) badges.hidden = true;
        setHidden(recommendRow, RECOMMEND_HIDDEN_ATTR, false);
        setHidden(ratingAnchor, RATING_HIDDEN_ATTR, false);
      }

      lastEnabled = enabled;
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (rafScheduled) return;
    rafScheduled = true;
    requestAnimationFrame(function () {
      rafScheduled = false;
      apply();
    });
  }

  function watchAttr() {
    if (!document.body) return;
    lastAttrValue = document.body.getAttribute(ATTR);

    new MutationObserver(function () {
      var next = document.body.getAttribute(ATTR);
      if (next === lastAttrValue && lastEnabled === isAbEnabled()) return;
      lastAttrValue = next;
      scheduleApply();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [ATTR]
    });

    new MutationObserver(function () {
      if (!isTargetPage()) return;
      if (
        !document.querySelector('[' + VARIANT_ATTR + ']') ||
        !document.querySelector('[' + BADGES_ATTR + ']') ||
        !getRatingRow()
      ) {
        scheduleApply();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    if (isDevVariantB() && document.body) {
      document.body.setAttribute(ATTR, 'true');
      document.documentElement.setAttribute(ATTR, 'true');
    }
    apply();
    watchAttr();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
